<p class="prelude">
    This information sheet describes the typical average properties of the specified soil to a depth of 1 metre, and should not be the
    primary source of data when making land use decisions on individual farms and paddocks. S-map correlates soils across New
    Zealand.
</p>

<style>
    p.prelude {
        margin-top: 20px;
    }
</style>